// Utility functions for i18n package
/**
 * Creates a default i18n configuration object
 * @param defaultLocale - The default locale to use
 * @param supportedLocales - Array of supported locales
 * @returns Configuration object for i18n setup
 */
export function createI18nConfig(defaultLocale, supportedLocales = ['en']) {
    return {
        defaultLocale,
        supportedLocales,
        fallbackLocale: defaultLocale,
    };
}
/**
 * Validates if a locale is supported
 * @param locale - The locale to validate
 * @param supportedLocales - Array of supported locales
 * @returns True if locale is supported, false otherwise
 */
export function isLocaleSupported(locale, supportedLocales) {
    return supportedLocales.includes(locale);
}
/**
 * Picks the first browser language that has a catalog, in the browser's preference order
 * @param browserLanguages - Languages from `navigator.languages`, most preferred first
 * @param supportedLocales - Locales that have messages
 * @returns The matching supported locale, or undefined when none match. A regional tag such as
 * `es-MX` matches `es` when only the base language is supported
 */
export function resolveBrowserLocale(browserLanguages, supportedLocales) {
    for (const language of browserLanguages) {
        const tag = language.toLowerCase();
        const baseLanguage = tag.split('-')[0];
        const match = supportedLocales.find((locale) => locale.toLowerCase() === tag) ??
            supportedLocales.find((locale) => locale.toLowerCase() === baseLanguage);
        if (match) {
            return match;
        }
    }
    return undefined;
}
